var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemServio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.32,
    height: 25.775,
    viewBox: "0 0 27.32 25.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "item-servi\\xE7o",
    transform: "translate(0 -14.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1429",
    "data-name": "Caminho 1429",
    d: "M27.32,21.187a.534.534,0,0,0-.306-.483l-4.9-2.308a.534.534,0,1,0-.454.966l3.879,1.825L13.66,26.775,1.787,21.187,13.66,15.6l3.764,1.771a.534.534,0,1,0,.454-.966l-3.991-1.878a.533.533,0,0,0-.454,0L.306,20.7a.534.534,0,0,0,0,.966l5.538,2.606L.306,26.882a.534.534,0,0,0,0,.966l5.537,2.606L.306,33.059a.534.534,0,0,0,0,.966L13.433,40.2a.538.538,0,0,0,.454,0l13.126-6.177a.534.534,0,0,0,0-.966l-5.537-2.606,5.537-2.606a.534.534,0,0,0,0-.966l-5.537-2.606,5.538-2.606A.534.534,0,0,0,27.32,21.187ZM12.407,27.364l-5.31,2.5-2.062-.97L10.4,26.42ZM8.35,30.453l5.536-2.605h0l6.336-2.981,2.03.955L10.26,31.352ZM7.1,24.866l2.041.96L3.774,28.3l-1.987-.935Zm13.127,6.177,5.31,2.5L13.66,39.129,1.787,33.542l5.31-2.5,6.336,2.982a.539.539,0,0,0,.454,0ZM13.66,32.952l-2.139-1.007,11.994-5.531,2.019.95Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1430",
    "data-name": "Caminho 1430",
    d: "M110.666,356.6l-1.094-.559a.534.534,0,1,0-.486.95l1.094.559a.534.534,0,1,0,.486-.95Z",
    transform: "translate(-102.99 -323.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1431",
    "data-name": "Caminho 1431",
    d: "M174.125,387.282l-1.094-.559a.534.534,0,1,0-.486.95l1.094.559a.534.534,0,0,0,.486-.95Z",
    transform: "translate(-163.063 -352.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1432",
    "data-name": "Caminho 1432",
    d: "M236.771,417.634a.534.534,0,0,0,.232.718l1.094.559a.534.534,0,1,0,.486-.95l-1.094-.559A.534.534,0,0,0,236.771,417.634Z",
    transform: "translate(-224.082 -381.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1433",
    "data-name": "Caminho 1433",
    d: "M296.5,388.671l1.094.559a.534.534,0,0,0,.486-.95l-1.094-.559a.534.534,0,1,0-.486.95Z",
    transform: "translate(-280.401 -353.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1434",
    "data-name": "Caminho 1434",
    d: "M355.991,358.989l1.094.559a.534.534,0,1,0,.486-.95l-1.094-.559a.534.534,0,1,0-.486.95Z",
    transform: "translate(-336.72 -325.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1435",
    "data-name": "Caminho 1435",
    d: "M361.377,69.461a.534.534,0,1,0,.086-.691A.539.539,0,0,0,361.377,69.461Z",
    transform: "translate(-342.01 -51.269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemServio);
export default __webpack_public_path__ + "static/media/item-serviço.dac4773fd3de406f09c833c1616a840f.svg";
export { ForwardRef as ReactComponent };